import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum CustomAccessKeys {
    ALLOCATE_ROLES_TO_USERS = 'allocateRolesToUsers',
    ANONYMIZE_APPLICANTS = 'anonymizeApplicants',
    AUDIT_PAYCHECKS = 'auditPaychecks',
    CANCEL_COURSE_WITHOUT_NOTIFICATION = 'cancelCourseWithoutNotification',
    CHARGE_PORTOKASSE = 'chargePortokasse',
    CREATE_PAYCHECK_FOR_OTHERS = 'createPaycheckForOthers',
    CREATE_TEMPORARY_USER = 'createTemporaryUser',
    EDIT_INVOICES = 'editInvoices',
    INITIALIZE_PERMISSION_HOOKS = 'initializePermissionHooks',
    LOGIN_AS = 'loginAs',
    MANAGE_JOB_AD_PUBLICATIONS = 'manageJobAdPublications',
    MANAGE_MAKEUP_CLAIMS = 'manageMakeupClaims',
    MANAGE_MAKEUP_REFUNDS = 'manageMakeupRefunds',
    MANAGE_MAKEUP_ROUNDS = 'manageMakeupRounds',
    MANAGE_PLACETEL_SCHEDULE = 'managePlacetelSchedule',
    PAYOUT_MAKEUP_REFUNDS = 'payoutMakeupRefunds',
    MOVE_PAST_LESSONS = 'movePastLessons',
    PRINT_ACTIVITY_SIGNUP = 'printActivitySignup',
    READ_STATS = 'readStats',
    REMOVE_ROLES_FROM_USERS = 'removeRolesFromUsers',
    REOPEN_MAKEUP_REFUNDS = 'reopenMakeupRefunds',
    RENDER_MAIL_TEMPLATES = 'renderMailTemplates',
    RENDER_WHATS_APP_MESSAGE_TEMPLATES = 'renderWhatsAppMessageTemplates',
    RUN_INSTITUTION_RESEARCH = 'runInstitutionResearch',
    SEE_PAYCHECK_OF_OTHERS = 'seePaycheckOfOthers',
    SEND_ACQUISITION_MAIL = 'sendAcquisitionMail',
    SEND_MAIL_AS_CUSTOMER = 'sendMailAsCustomer',
    SHARE_ACCESS = 'shareAccess',
    START_CRON_JOBS = 'startCronJobs',
    STOP_CRON_JOBS = 'stopCronJobs',
    UPDATE_COURSE_LINKS = 'updateCourseLinks',
    USE_BOOK_INVOICE_GENERATOR = 'useBookInvoiceGenerator',
    USE_GMAPS_DISTANCE_MATRIX = 'useGmapsDistanceMatrix',
    USE_SEPA_TOOLS = 'useSepaTools',
    VIEW_ACQUISITION_BOARD = 'viewAcquisitionBoard',
    VIEW_AS_ROLE = 'viewAsRole',
    WRITE_COURSE_LOGS_FOR_OTHERS = 'writeCourseLogsForOthers',
    WRITE_COURSE_LOGS_IN_FUTURE = 'writeCourseLogsInFuture',
}

export namespace CustomAccessKeys {
    type Data = {
        text: string;
    }
    export const Record: Record<CustomAccessKeys, Data> = {
        [CustomAccessKeys.ALLOCATE_ROLES_TO_USERS]: {text: 'Nutzern Rollen zuweisen'},
        [CustomAccessKeys.ANONYMIZE_APPLICANTS]: {text: 'Bewerber:innen sofort endgültig anonymisieren (DSGVO-Löschung)'},
        [CustomAccessKeys.AUDIT_PAYCHECKS]: {text: 'Abrechnungen prüfen und zur Zahlung freigeben'},
        [CustomAccessKeys.CANCEL_COURSE_WITHOUT_NOTIFICATION]: {text: 'Kurstermine absagen, ohne Eltern/Schüler:innen zu informieren'},
        [CustomAccessKeys.CHARGE_PORTOKASSE]: {text: 'Portokasse aufladen'},
        [CustomAccessKeys.CREATE_PAYCHECK_FOR_OTHERS]: {text: 'Lohnabrechnung anderer bestätigen'},
        [CustomAccessKeys.CREATE_TEMPORARY_USER]: {text: 'Temporäre Benutzer erstellen'},
        [CustomAccessKeys.EDIT_INVOICES]: {text: 'Rechnungen bearbeiten & korrigieren (Entwürfe ändern und abschließen, Storno + neue Rechnung)'},
        [CustomAccessKeys.INITIALIZE_PERMISSION_HOOKS]: {text: 'Berechtigungsroutinen initialisieren'},
        [CustomAccessKeys.LOGIN_AS]: {text: 'Als andere Benutzer einloggen'},
        [CustomAccessKeys.MANAGE_JOB_AD_PUBLICATIONS]: {text: 'Stellenanzeigen-Veröffentlichungen verwalten'},
        [CustomAccessKeys.MANAGE_MAKEUP_CLAIMS]: {text: 'Nachholansprüche verwalten (Status setzen, Art ändern)'},
        [CustomAccessKeys.MANAGE_MAKEUP_REFUNDS]: {text: 'Rückerstattungen aus Kursausfällen verwalten (Betrag, Auszahlungsweg, FastBill-Beleg, erledigt)'},
        [CustomAccessKeys.MANAGE_MAKEUP_ROUNDS]: {text: 'Online-Nachholrunden (Samstag) planen, Eltern anschreiben und abschließen'},
        [CustomAccessKeys.MANAGE_PLACETEL_SCHEDULE]: {text: 'Dienstplan des Placetel-Call-Centers verwalten'},
        [CustomAccessKeys.MOVE_PAST_LESSONS]: {text: 'Vergangene Stunden einmalig verschieben'},
        [CustomAccessKeys.PAYOUT_MAKEUP_REFUNDS]: {text: 'Rückerstattungen auszahlen (SEPA-Sammelüberweisung erstellen)'},
        [CustomAccessKeys.PRINT_ACTIVITY_SIGNUP]: {text: 'Anmeldung eines Kunden drucken'},
        [CustomAccessKeys.READ_STATS]: {text: 'Statistiken lesen'},
        [CustomAccessKeys.REMOVE_ROLES_FROM_USERS]: {text: 'Rollen von Nutzern entfernen'},
        [CustomAccessKeys.REOPEN_MAKEUP_REFUNDS]: {text: 'Ausgezahlte Rückerstattungen mit Begründung wieder öffnen'},
        [CustomAccessKeys.RENDER_MAIL_TEMPLATES]: {text: 'E-Mail-Templates rendern'},
        [CustomAccessKeys.RUN_INSTITUTION_RESEARCH]: {text: 'Schulen mit Claude recherchieren lassen (kostenpflichtig)'},
        [CustomAccessKeys.RENDER_WHATS_APP_MESSAGE_TEMPLATES]: {text: 'WhatsApp-Nachrichten-Templates rendern'},
        [CustomAccessKeys.SEE_PAYCHECK_OF_OTHERS]: {text: 'Lohnabrechnung anderer einsehen'},
        [CustomAccessKeys.SEND_ACQUISITION_MAIL]: {text: 'Akquise-Mails an Schulen aus Akquiselisten senden und Antworten sehen (Vertrieb)'},
        [CustomAccessKeys.SEND_MAIL_AS_CUSTOMER]: {text: 'E-Mails über die in den Stammdaten hinterlegte Adresse versenden'},
        [CustomAccessKeys.SHARE_ACCESS]: {text: 'Zugriffsrechte freigegebener Nutzer bearbeiten'},
        [CustomAccessKeys.START_CRON_JOBS]: {text: 'Cron-Jobs starten'},
        [CustomAccessKeys.STOP_CRON_JOBS]: {text: 'Cron-Jobs stoppen'},
        [CustomAccessKeys.UPDATE_COURSE_LINKS]: {text: 'Verknüpfungen zwischen Kursen aktualisieren'},
        [CustomAccessKeys.USE_BOOK_INVOICE_GENERATOR]: {text: 'Buchungsrechnungs-Generator nutzen'},
        [CustomAccessKeys.USE_GMAPS_DISTANCE_MATRIX]: {text: 'Google Maps Distance Matrix nutzen'},
        [CustomAccessKeys.USE_SEPA_TOOLS]: {text: 'SEPA-Tools nutzen'},
        [CustomAccessKeys.VIEW_ACQUISITION_BOARD]: {text: 'Akquise-Board aller Akquiselisten einsehen'},
        [CustomAccessKeys.VIEW_AS_ROLE]: {text: 'Ansicht als Rolle (nur lesen): Vanilla mit den Rechten einer Rolle ansehen'},
        [CustomAccessKeys.WRITE_COURSE_LOGS_FOR_OTHERS]: {text: 'Kurs-Logs für andere schreiben'},
        [CustomAccessKeys.WRITE_COURSE_LOGS_IN_FUTURE]: {text: 'Kurs-Logs für die Zukunft schreiben'},
    };

    export const Items = mapRecordToItems(Record);
}
